import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '@hiiretail/core';

// Local v5-compatible replacement for `@hiiretail/core`'s `LoggedInRouteGuard`,
// which depends on `react-router@6`'s `Navigate`. Since the host app is on
// `react-router-dom@5`, we use `Redirect` here.
export const LoggedInRouteGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Redirect to="/login" />;
};
